export default __webpack_public_path__ + "static/media/regulatory--wear-seat-belt--g1.f47a44cf.png";